<div id="blocking-screen">
  <div id="spinner-container">
    <ion-spinner color="medium" name="bubbles"></ion-spinner>
    <ion-button [class.show]="showCancelButton" (click)="cancelLoad(true)" color="danger"> Cancelar</ion-button>
  </div>
</div>
